/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PutUsersMeOptions, PutUsersMeResponses } from '../types/PutUsersMe'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Update the current user's information. The information will be refreshed based on the access token
 * {@link /users/me/}
 */
export function putUsersMe<ThrowOnError extends boolean = true>(options: Options<PutUsersMeOptions, ThrowOnError> = {}): Unwrappable<RequestResult<PutUsersMeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'PUT', url: '/users/me/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PutUsersMeResponses, ThrowOnError>>)
}
